import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSpinner, faSearch } from '@fortawesome/free-solid-svg-icons';
import ModalOverlay from '../../../components/ui/ModalOverlay/ModalOverlay';
import type { ContactSearchResult } from '../../../types/caseFile';
import s from '../CaseFilePage.module.css';

interface ReassignModalProps {
  caseRef: string;
  reassignSearch: string;
  handleReassignSearch: (q: string) => void;
  reassignResults: ContactSearchResult[];
  reassignSelected: ContactSearchResult | null;
  setReassignSelected: (c: ContactSearchResult | null) => void;
  handleReassignSave: () => void;
  isPending: boolean;
  onClose: () => void;
}

export default function ReassignModal({
  caseRef,
  reassignSearch,
  handleReassignSearch,
  reassignResults,
  reassignSelected,
  setReassignSelected,
  handleReassignSave,
  isPending,
  onClose,
}: ReassignModalProps) {
  return (
    <ModalOverlay onClose={onClose} title="Reassign Contact">
      <div className={s.modalForm}>
        <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--gray-600)' }}>
          Reassigning case <strong>{caseRef}</strong> to a new contact.
        </p>
        <div className={s.formGroup}>
          <label>Search Contacts</label>
          <div className={s.searchInputWrap}>
            <FontAwesomeIcon icon={faSearch} className={s.searchIcon} />
            <input
              type="text"
              value={reassignSearch}
              onChange={(e) => handleReassignSearch(e.target.value)}
              placeholder="Type name, email or ID…"
            />
          </div>
        </div>

        {reassignResults.length > 0 && (
          <div className={s.searchResults}>
            {reassignResults.map((c) => (
              <div
                key={c.ContactID}
                className={`${s.searchResultItem} ${reassignSelected?.ContactID === c.ContactID ? s.searchResultSelected : ''}`}
                onClick={() => setReassignSelected(c)}
              >
                <strong>{c.name || 'Unknown'}</strong>
                <span>ID: {c.ContactID}</span>
                <span>
                  {c.email || ''} {c.phone ? `• ${c.phone}` : ''}
                </span>
              </div>
            ))}
          </div>
        )}

        {reassignSelected && (
          <div className={s.selectedContactInfo}>
            <h4>Selected Contact</h4>
            <p>
              <strong>Name:</strong> {reassignSelected.name}
            </p>
            <p>
              <strong>ID:</strong> {reassignSelected.ContactID}
            </p>
            <p>
              <strong>Email:</strong> {reassignSelected.email || 'N/A'}
            </p>
            <p>
              <strong>Phone:</strong> {reassignSelected.phone || 'N/A'}
            </p>
          </div>
        )}

        <div className={s.modalActions}>
          <button className={s.btnSecondary} onClick={onClose}>
            Cancel
          </button>
          <button
            className={s.btnPrimary}
            onClick={handleReassignSave}
            disabled={!reassignSelected || isPending}
          >
            {isPending ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <FontAwesomeIcon icon={faCheck} />
            )}
            Reassign
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
